import React from 'react';
import Button from 'components/button/button'
import { connect } from 'react-redux'

import {
    openModal,
} from 'state/actions'

const StatusClose = props => {
    const {
        openModal,
        account
    } = props

    return (
        <div className="widget box close-container">
            <h3>
                Close your account?
            </h3>
            <p>
                Click below to delete this organization, and all its data. This operation can't be undone.
            </p>
            <Button 
                level="high"
                size="big"
                label="Delete organization"
                callback={() => openModal('close', 'account', account)}
            />
        </div>
    )
};

export default connect(() => {}, {
    openModal
})(StatusClose)


// WEBPACK FOOTER //
// ./src/sections/status/status-close.jsx